/* ROJO Halloween 2026: approved file entrance, isolated from the OS systems. */
(() => {
  if (window.__rojoHalloweenEntry) return;
  const active = new Map();

  window.__rojoHalloweenEntry = (root, resume) => {
    const entry = root.querySelector('[data-rojo-file-entry]');
    if (!entry || root.dataset.rojoCursedEntry === 'complete') return false;
    if (active.has(root)) return true;

    const button = entry.querySelector('.rc-open');
    const win = entry.querySelector('.rc-window');
    if (!button || !win) return false;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let reducedMotion = motion.matches;
    const filename = entry.querySelector('.rc-filename');
    const originalName = filename?.textContent || 'ROJO_HALLOWEEN.exe';
    let burstIndex = 0;
    let nextDisturbance = null;
    const timers = new Set();
    const siblings = Array.from(root.children).filter(el => el !== entry);
    const oldInert = siblings.map(el => el.inert);
    let opening = false;
    let disposed = false;
    let recoveringTimer = null;
    siblings.forEach(el => { el.inert = true; });

    const later = (callback, delay) => {
      const timer = window.setTimeout(() => {
        timers.delete(timer);
        if (!disposed && root.isConnected) callback();
      }, delay);
      timers.add(timer);
      return timer;
    };
    const cleanup = () => {
      disposed = true;
      timers.forEach(timer => window.clearTimeout(timer));
      timers.clear();
      if (recoveringTimer !== null) window.clearTimeout(recoveringTimer);
      button.removeEventListener('click', open);
      document.removeEventListener('visibilitychange', onVisibility);
      motion.removeEventListener?.('change', onMotion);
      resetDisturbance();
      siblings.forEach((el, i) => { el.inert = oldInert[i]; });
      active.delete(root);
    };
    const finish = () => {
      if (disposed) return;
      cleanup();
      root.dataset.rojoCursedEntry = 'complete';
      entry.hidden = true;
      resume();
    };
    const resetDisturbance = () => {
      win.classList.remove('is-disturbed');
      if (filename) filename.textContent = originalName;
    };
    const scheduleDisturbance = delay => {
      if (nextDisturbance !== null) {
        window.clearTimeout(nextDisturbance);
        timers.delete(nextDisturbance);
      }
      nextDisturbance = null;
      if (!opening && !disposed && !reducedMotion && !document.hidden) {
        nextDisturbance = later(disturb, delay);
      }
    };
    const disturb = () => {
      nextDisturbance = null;
      if (opening || reducedMotion || document.hidden) return;
      win.classList.add('is-disturbed');
      const fragments = ['ROJO_HA░░OWEEN.exe', 'RØJO_HALLOWEEN.▒xe', 'ROJO_//LOWEEN.exe'];
      if (filename) filename.textContent = fragments[burstIndex % fragments.length];
      later(() => { if (!opening && !reducedMotion && !document.hidden && filename) filename.textContent = 'RØJØ_HA//OWEEN.exe'; }, 210);
      later(resetDisturbance, 680);
      // Irregular, continuing bursts: visible quickly, with movement between them.
      const gaps = [4700, 6300, 5200, 7800, 5600];
      scheduleDisturbance(gaps[burstIndex++ % gaps.length]);
    };
    const onVisibility = () => {
      entry.classList.toggle('rc-paused', document.hidden);
      if (document.hidden) resetDisturbance();
      scheduleDisturbance(850);
    };
    const onMotion = event => {
      reducedMotion = event.matches;
      if (reducedMotion) resetDisturbance();
      scheduleDisturbance(850);
    };
    const open = () => {
      if (opening || disposed) return;
      opening = true;
      entry.classList.add('is-opening');
      resetDisturbance();
      scheduleDisturbance(0);
      button.disabled = true;
      button.textContent = 'OPENING…';
      if (!reducedMotion) win.classList.add('is-disturbed');
      // Finish even if an optional visual callback fails after the click.
      recoveringTimer = window.setTimeout(() => { if (root.isConnected) finish(); }, 3000);
      later(() => {
        win.classList.remove('is-disturbed');
        win.classList.add('is-opened');
        entry.querySelector('[data-rc-title]').textContent = 'FILE OPENED YOU';
        entry.querySelector('[data-rc-status]').textContent = 'Connection established';
        entry.querySelector('.rc-message').textContent = 'WE’VE BEEN WAITING FOR YOU.';
      }, 320);
      later(() => {
        win.hidden = true;
        entry.querySelector('.rc-underneath').hidden = true;
        entry.querySelector('.rc-echo').hidden = true;
      }, 1900);
      later(finish, 2150);
    };

    active.set(root, cleanup);
    button.addEventListener('click', open);
    document.addEventListener('visibilitychange', onVisibility);
    motion.addEventListener?.('change', onMotion);
    scheduleDisturbance(850);

    // One small noise tile, moved by CSS. No downloads or video.
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 180; canvas.height = 160;
      const context = canvas.getContext('2d');
      if (context) {
        const noise = context.createImageData(180, 160);
        let seed = 41;
        for (let i = 0; i < noise.data.length; i += 4) {
          seed = (seed * 1664525 + 1013904223) >>> 0;
          const value = seed >>> 24;
          noise.data[i] = value; noise.data[i + 1] = value * .72;
          noise.data[i + 2] = value * .63; noise.data[i + 3] = 95;
        }
        context.putImageData(noise, 0, 0);
        entry.querySelector('.rc-grain').style.backgroundImage = `url(${canvas.toDataURL()})`;
      }
    } catch (_) { /* Texture is optional; OPEN FILE always remains usable. */ }
    return true;
  };

  // Section reloads must remove the old entrance timers and event handlers.
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of active) {
      if (!root.isConnected || event.target === root || event.target.contains(root)) cleanup();
    }
  });
})();
